import { LineChart } from 'app/agriculture/charts/LineChart/LineChart';
import { getTankLevelChartOptions } from 'app/agriculture/routes/Tanks/TankDetails/components/TankLevelChart/TankLevelOptions';
import {
    getAggregateDataFieldRecord,
    useAggregateChartData,
} from 'app/agriculture/hooks/useAggregateChartData/useAggregateChartData';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { ChartContextProvider } from 'app/agriculture/charts/ChartContextProvider';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useThrottledNow } from 'app/agriculture/AgTimeline/hooks/useThrottledNow';
import { endOfDay, sub as subDuration } from 'date-fns';
import { MenuItem, TextField } from '@mui/material';
import './TankLevelChart.scss';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';

export function TankLevelChart({ deviceId }: { deviceId: string }) {
    const device = useDevice({ deviceId });
    const now = useThrottledNow();
    const end = endOfDay(now);
    const start = subDuration(end, { days: 7 });

    const data = useAggregateChartData({
        snapshotType: brandConfig[device.brand].levelSnapshotType,
        interval: { start, end },
        deviceId,
        intervalUnit: 'day',
    });

    const chartOptions = getTankLevelChartOptions({
        volumeRemainingData: getAggregateDataFieldRecord(data, 'volumeRemainingAvg'),
        intervalUnit: 'day',
        percentageUnit: '%',
        secondaryMeasurementUnit: 'L',
    });

    return (
        <ContentBox.Section className="TankLevelChart" heading="Level History">
            <ChartContextProvider intervalUnit={'day'}>
                <div className="TankLevelChart__drop-down">
                    <FakeDropdown />
                </div>
                <LineChart
                    data={getAggregateDataFieldRecord(data, 'percentageRemainingAvg')}
                    chartOptionsOverride={chartOptions}
                    showCurrentValue={false}
                />
            </ChartContextProvider>
        </ContentBox.Section>
    );
}

export function FakeDropdown() {
    return (
        <TextField className="TankLevelChart__select" select disabled defaultValue="Last 7 days">
            <MenuItem value="Last 7 days">Last 7 days</MenuItem>
        </TextField>
    );
}
